import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Crown } from 'lucide-react';

const tierColors = {
  free: 'bg-gray-100 text-gray-700',
  silver: 'bg-gray-200 text-gray-800',
  gold: 'bg-[#D4A574]/20 text-[#C4844A]',
  platinum: 'bg-[#2C1810] text-[#D4A574]'
};

const AdminMembersTab = ({ members }) => {
  const stats = {
    total: members.length,
    active: members.filter(m => m.status === 'active').length,
    free: members.filter(m => m.tier === 'free').length,
    silver: members.filter(m => m.tier === 'silver').length,
    gold: members.filter(m => m.tier === 'gold').length,
    platinum: members.filter(m => m.tier === 'platinum').length,
  };

  return (
    <div className="space-y-6">
      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {[
          { label: 'Total', value: stats.total, color: 'bg-[#FDF8F0]' },
          { label: 'Active', value: stats.active, color: 'bg-green-50' },
          { label: 'Free', value: stats.free, color: 'bg-gray-50' },
          { label: 'Silver', value: stats.silver, color: 'bg-gray-100' },
          { label: 'Gold', value: stats.gold, color: 'bg-[#D4A574]/10' },
          { label: 'Platinum', value: stats.platinum, color: 'bg-[#2C1810]/5' },
        ].map(s => (
          <div key={s.label} className={`${s.color} rounded-xl p-3 text-center`}>
            <p className="text-xl font-bold text-[#2C1810]">{s.value}</p>
            <p className="text-xs text-[#7a6555]">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Members List */}
      {members.length === 0 ? (
        <div className="text-center py-12 text-[#7a6555]" data-testid="no-members">
          <Crown size={48} className="mx-auto text-[#D4A574] mb-4" />
          <p className="text-lg font-semibold text-[#2C1810] mb-1">No members yet</p>
          <p className="text-sm">Members will appear here once they join.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {members.map(m => (
            <Card key={m.id} className="shadow-sm border border-[#E8DFD3] bg-white" data-testid={`member-item-${m.id}`}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#5C7A3A]/10 flex items-center justify-center flex-shrink-0">
                  <Crown size={16} className="text-[#5C7A3A]" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-[#2C1810] text-sm">{m.name}</p>
                  <p className="text-xs text-[#7a6555]">{m.email} &middot; {m.phone}</p>
                </div>
                <span className={`text-xs font-bold px-3 py-1 rounded-full capitalize ${tierColors[m.tier] || 'bg-gray-100 text-gray-700'}`}>
                  {m.tier}
                </span>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${
                  m.status === 'active' ? 'bg-green-50 text-green-700' :
                  m.status === 'cancelled' ? 'bg-red-50 text-red-600' :
                  'bg-yellow-50 text-yellow-700'
                }`}>
                  {m.status}
                </span>
                {m.amount > 0 && (
                  <span className="text-sm font-bold text-[#2C1810]">{'\u20B9'}{m.amount}</span>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminMembersTab;
